export default __webpack_public_path__ + "static/media/flag.dcb60345.svg";